<template>
  <a :class="['v-navbar-navigation-item', { 'v-navbar-navigation-item--active': active }]">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-navbar-navigation-item {
  white-space: nowrap;
  text-decoration: none;
  color: theme-color("dark");
  padding: $spacer * 0.5 $spacer 0 $spacer;
  margin: 0;
  font-size: 0.875rem;
  outline: 0;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  &::after {
    content: "";
    display: block;
    margin-top: $spacer * 0.25;
    border-top: 2px solid transparent;
  }

  @include media-breakpoint-up(lg) {
    margin: 0 $spacer * 0.5;
  }

  @include media-breakpoint-up(md) {
    font-size: 1rem;
  }

  &:active,
  &:hover,
  &--active {
    color: theme-color("primary");
  }

  &--active {
    font-weight: bold;
  }

  &--active::after {
    border-color: theme-color("primary");
  }
}
</style>
